import React, { FunctionComponent, useMemo } from "react";
import SaleContext, { SaleContextValue } from "contexts/SaleContext";
import useSaleState from "hooks/useSaleState";
import useSalePrice from "hooks/useSalePrice";
import useSaleHoneyReward from "hooks/useSaleHoneyReward";

const SaleProvider: FunctionComponent = ({ children }) => {
  const [isSaleActive, readSaleState] = useSaleState();
  const [price, readPrice] = useSalePrice();
  const [honeyReward, readHoneyReward] = useSaleHoneyReward();

  const contextValue = useMemo<SaleContextValue>(
    () => ({
      isSaleActive,
      price,
      honeyReward,
      readSaleState,
      readPrice,
      readHoneyReward,
    }),
    [
      isSaleActive,
      price,
      honeyReward,
      readSaleState,
      readPrice,
      readHoneyReward,
    ]
  );

  return (
    <SaleContext.Provider value={contextValue}>{children}</SaleContext.Provider>
  );
};

export default SaleProvider;
